import { GatsbyLink, GatsbyLinkProps } from "@mgdx-libs/link";
import { cx } from "cva";
import React from "react";

import { SubtleButtonProps, variants } from ".";

export const SubtleButtonLink = ({
  className,
  children,
  align,
  radius,
  disabled,
  ...props
}: Readonly<SubtleButtonProps & Omit<GatsbyLinkProps<EmptyObject>, "ref">>) => (
  <GatsbyLink aria-disabled={disabled} className={cx(className, variants({ align, radius }))} {...props}>
    {children}
  </GatsbyLink>
);
